import React, { useState, useEffect } from "react"
import "../../pages/InstallDirectPage/InstallDirectPage.scss"
import "../../components/TMHBanner/TMHBannerStyles.css"
import TMHBanner from "../../components/TMHBanner/TMHBanner"
import FirstSlide from "./slide1.png"
import SecondSlide from "./slide2.png"
import ThirdSlide from "./slide3.png"
import Carousel from "react-bootstrap/Carousel"
import "bootstrap/dist/css/bootstrap.css"
import { useNavigate } from "react-router-dom"
import { useTitle } from 'react-use'
import ReactGA from "react-ga4"


const stepData = [
  {
    name: "Step 1",
    textNormal: "Visit The Movie House on ",
    textRedColor: "Roku.com by clicking here🡵",
    href: "https://channelstore.roku.com/details/d1f88eaf8287503497af4cdefdaba594/the-movie-house-tv",
    description: `If you are signed in already, you can add the channel directly by simply clicking “add channel”. If not, sign in with your Roku account credentials to proceed.`,
    img: FirstSlide,
    altImg: "First slide"
  },
  {
    name: "Step 2",
    textNormal: "Turn on your Roku device and open",
    textRedColor: ` The Movie House app`,
    description: `The Movie House app can be seen in your channels list. Navigate to it and open the app.`,
    img: SecondSlide,
    altImg: "Second slide",
  },
  {
    name: "Step 3",
    textNormal: `Select`,
    textRedColor: ` “Sign In With Your Member PIN”`,
    description: `Once you open the app, select “Sign In With Your Member PIN”. Add your PIN to link your account. Your PIN can also be seen in the next step.`,
    img: ThirdSlide,
    altImg: "Third slide",
  },
]

export default function VisitRokuWebsitePage() {
  const [title, setTitle] = useState("Visit Roku Website - The Movie House TV - Step 1")
  useTitle(title)

  useEffect(() => {
    ReactGA.send("pageview")
  })

  const navigate = useNavigate()
  const [index, setIndex] = useState(0)
  
  const handleSelect = (selectedIndex, e = null) => {
    if (index === stepData.length - 1 && (selectedIndex === 0 || selectedIndex === stepData.length)) {
      navigate("/verification/vrw")
      return
    }
    // Prevent change slide if FirstSlide or LastSlide
    if (index === 0 && selectedIndex === stepData.length - 1) return
    setTitle("Visit Roku Website - The Movie House TV - Step " + String(selectedIndex + 1))
    ReactGA.send("pageview")
    setIndex(selectedIndex)
  }

  return (
    <TMHBanner classOption="only-gradient">
      <div className="redirect-page">
        <div className="redirect-background" />
        <Carousel interval={null} activeIndex={index} onSelect={handleSelect}>
          {stepData.map((item, index) => (
            <Carousel.Item key={index}>
              <div className="step-wrapper">
                <h3 className="step">{item.name}</h3>
                <h3 className="headline">
                  {item.textNormal}
                  {item.href ? (
                    <a
                      href={item.href}
                      rel="noreferrer"
                      target="_blank"
                      className="red-text"
                    >
                      {item.textRedColor}
                    </a>
                  ) : (
                    <span className="red-text">{item.textRedColor}</span>
                  )}

                  {item.textNormal2 && item.textNormal2}
                  {item.textRedColor2 && (
                    <span className="red-text">{item.textRedColor2}</span>
                  )}
                </h3>
              </div>
              <img
                className="d-block w-100 slide-image"
                src={item.img}
                alt={item.altImg}
              />
              <button onClick={() => handleSelect(index + 1)} className="next-step">NEXT STEP</button>
              <p className="description">{item.description}</p>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    </TMHBanner>
  )
}
